import { Router } from "./routes";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { queryClient } from "@/api/common";
import { useEffect } from "react";
import i18n from "./i18n";

const App = () => {
	useEffect(() => {
		try {
			i18n.reloadResources();
		} catch (error) {
			console.error("Failed to load language", error);
		}
	}, []);

	return (
		<MantineProvider>
			<Notifications zIndex={10000} />
			<QueryClientProvider client={queryClient}>
				<Router />
				<ReactQueryDevtools />
			</QueryClientProvider>
		</MantineProvider>
	);
};

export default App;
